import {
  DashboardTransactionsHistory,
  DashboardServicesSummary,
  DashboardAccountsDialog,
  DashboardNotifications,
  DashboardWelcomeHero,
  DashboardEmployees,
  DashboardVehicles,
  DashboardBanner,
  DashboardHeader,
  DashboardWallet,
} from '@pages/dashboard/containers';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetDashboard } from '@pages/dashboard/hooks';
import { HasPermission } from '@shared/components';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Routes } from '@shared/enums';
import { toast } from '@ui/components';

export const Dashboard = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { data } = useGetDashboard();
  const { t } = useTranslation();

  const [dashboardDialogVisible, setDashboardDialogVisible] = useState(false);

  const handleTopUpClick = () => {
    if (data?.accounts?.length === 0) {
      toast.error(t('DASHBOARD.WALLET.NO_ACCOUNT_ERROR'));
      return;
    }
    if (data?.accounts?.length === 1) {
      navigate(`../${Routes.COST_CENTER}`, {
        state: { isTopUpDrawerOpen: true },
      });
    } else {
      setDashboardDialogVisible(true);
    }
  };

  useEffect(() => {
    if (state?.accountDialogVisible) {
      handleTopUpClick();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <HasPermission permissionFeature="DASHBOARD" permissionType="READ">
      <DashboardHeader />
      <DashboardWelcomeHero onTopUpClick={handleTopUpClick} className="mb-6" />

      <div className="grid grid-cols-2 xl:grid-cols-12 auto-rows-[160px] gap-6">
        <DashboardWallet
          className="col-span-1 xl:col-span-4 row-span-2"
          onTopUpClick={handleTopUpClick}
        />
        <DashboardServicesSummary className="col-span-1 xl:col-span-4 row-span-2" />
        <DashboardNotifications className="col-span-2 xl:col-span-4 row-span-2" />
        <DashboardTransactionsHistory className="col-span-2 xl:col-span-9 row-span-4" />
        <DashboardBanner className="col-span-2 xl:col-span-3 row-span-2" />
        <DashboardEmployees className="col-span-1 xl:col-span-3 row-span-1" />
        <DashboardVehicles className="col-span-1 xl:col-span-3 row-span-1" />
      </div>

      <DashboardAccountsDialog
        setIsOpen={setDashboardDialogVisible}
        isOpen={dashboardDialogVisible}
        onTopUpClick={handleTopUpClick}
      />
    </HasPermission>
  );
};
